// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { updateProgress } from '../../apis/course';
import { postOnlineCourseChaptersProgressActions } from '../actionCreators/postOnlineCourseChaptersProgressActions';
import { RootAction } from '../rootActionCreator';

const outputActions = {
  success: postOnlineCourseChaptersProgressActions.success,
  failure: postOnlineCourseChaptersProgressActions.failure
};

type RequestActionTypes = ActionType<
  typeof postOnlineCourseChaptersProgressActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

export const postOnlineCourseChaptersProgressEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(postOnlineCourseChaptersProgressActions.request)
    ),
    switchMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, progress } = action.payload;
      // send api promise
      return updateProgress(id, progress)
        .then((response) => {
          return postOnlineCourseChaptersProgressActions.success({
            id,
            progress: response.data.progress,
            revisedTime: response.data.revisedTime
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          return postOnlineCourseChaptersProgressActions.failure({ error });
        });
    })
  );
};
